import styled from 'styled-components';
import Select from 'react-select';
import EllipsisText from 'react-ellipsis-text';
import { ModalBackdrop, modalPanelSheet } from '../ModalPrimitives.styled';

export { ModalBackdrop };

export const ModalContainer = styled.div`
  ${modalPanelSheet}
  position: relative;
  width: 100%;
  max-width: 620px;
  max-height: min(90vh, 820px);
  overflow-y: auto;
  padding: 20px 24px 24px;

  @media (max-width: 767px) {
    align-self: flex-end;
    max-width: 100%;
    max-height: 88vh;
    border-radius: ${p =>
      `${p.theme.modal.radiusSheet} ${p.theme.modal.radiusSheet} 0 0`};
    padding: 16px 16px 24px;
  }
`;
export const CategoriesWrap = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto;
  justify-items: center;
`;
export const CategoryText = styled(EllipsisText)`
  color: ${p => p.theme.colors.text.text};
  font-family: Kulim Park;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.04em;

  @media (max-width: 560px) {
    max-width: 100%;
    text-align: center;
  }
`;
export const CategoryBtn = styled.button`
  width: 64px;
  height: 64px;
  border: none;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  box-sizing: border-box;
  cursor: pointer;
  :hover {
    background-color: ${p => p.theme.colors.main.orangeLight};
    border-radius: 16px;
  }
  :focus {
    background-color: ${p => p.theme.colors.main.orangeLight};
    border-radius: 16px;
  }
  :active {
    background-color: ${p => p.theme.colors.main.orangeLight};
    border-radius: 16px;
  }

  @media (max-width: 560px) {
    width: 100%;
    max-width: 176px;
    min-height: 78px;
    margin-left: auto;
    margin-right: auto;
  }
`;
export const SelectedCategoryBtn = styled(CategoryBtn)`
  background-color: ${p => p.theme.colors.main.orangeLight};
  border-radius: 16px;
`;
export const CategoryContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px 6px;
  margin-bottom: 22px;
  padding: 0;
  list-style: none;

  @media (max-width: 560px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 12px;
    justify-content: stretch;

    & > li {
      display: flex;
      justify-content: center;
      min-width: 0;
      width: 100%;
    }
  }
`;
export const Text = styled.p`
  font-family: 'Kulim Park';
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.04em;
  color: ${p => p.theme.colors.text.text};
  margin: 0;
`;
export const CloseBtnWpar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
`;
export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
`;
export const ModalHeaderTitles = styled.div`
  flex: 1;
  min-width: 0;
`;
export const CloseBtn = styled.button`
  width: 36px;
  height: 36px;
  background-color: ${p =>
    p.theme.ui.scheme === 'dark' ? '#1e293b' : '#f8fafc'};
  border: 1px solid ${p => p.theme.colors.main.grayLight};
  border-radius: 9999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  transition: 200ms ease;

  :hover {
    background-color: ${p => p.theme.colors.main.orangeLight};
    border-color: ${p => p.theme.colors.main.orangeMain};
  }
`;
export const ModalTitle = styled.p`
  font-family: 'Kulim Park';
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  color: ${p => p.theme.colors.main.orangeMain};
  margin: 0 0 4px;
`;
export const ModalSubtitle = styled.p`
  font-size: 13px;
  line-height: 1.4;
  color: ${p => p.theme.colors.text.gray};
  margin: 0;
`;
export const Divider = styled.div`
  height: 1px;
  background: ${p => p.theme.colors.main.grayLight};
  margin-bottom: 16px;

  @media (max-width: 767px) {
    margin-bottom: 12px;
  }
`;
export const BtnWrap = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 24px;
`
export const Input = styled.input`
  color: ${p => p.theme.colors.text.text};
  border: 0px;
  font-size: 12px;
  line-height: 1.5;
  background: ${p => p.theme.colors.main.orangeLight};
  border-radius: 30px;
  border: none;
  width: 100%;
  padding: 11px 12px;
  box-sizing: border-box;
  ::placeholder {
    color: ${p => p.theme.colors.text.gray};
  }
`;
export const Label = styled.label`
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.04em;
  color: ${p => p.theme.colors.text.text};
  margin-bottom: 4px;
`;
export const ImgLocation = styled.img`
  position: absolute;
  top: 29px;
  left: 12px;
`
export const Switcher = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 57px;
  background: ${p => p.theme.colors.main.white};
  box-shadow: ${p => p.theme.modal.elevatedSoft};
  border-radius: 30px;
  margin-bottom: 12px;
`;
export const OperationText = styled.p`
  font-weight: 700;
  font-size: 12px;
  line-height: 1.5;
  color: ${p => p.theme.colors.main.orangeMain};
  margin-left: 32px;
  margin-right: 32px;
`;
export const BtnArrow = styled.button`
  cursor: pointer;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: transparent;
  border: none;
  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1);

  &:focus {
    transform: scale(0.9);
  }
`;
/////////////////////////Select
export const WalletSelect = styled(Select)`
  .wallet-select__control {
    background: ${p => p.theme.colors.main.white};
    border: 1px solid ${p => p.theme.colors.main.orangeLight};
    border-radius: 16px;
    justify-content: center;
    margin-bottom: 16px;
    margin-top: 16px;
    box-shadow: none;
  }
  .wallet-select__control--menu-is-open {
    border-radius: 16px 16px 0px 0px;
  }
  .wallet-select__indicator-separator {
    display: none;
  }
  .wallet-select__placeholder {
    font-family: 'Kulim Park';
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: 0.04em;
    color: ${p => p.theme.colors.main.orangeMain};
    text-align: center;
  }
  .css-tj5bde-Svg {
    fill: ${p => p.theme.colors.main.orangeMain};
    stroke: ${p => p.theme.colors.main.orangeMain};
    margin-right: 16px;
  }
  .css-1xc3v61-indicatorContainer {
    padding: 0;
  }
  .wallet-select__input-container {
    padding-top: 11px;
    padding-bottom: 11px;
  }
  .css-13cymwt-control:hover {
    border-color: ${p => p.theme.colors.main.orangeLight};
  }
  .wallet-select__single-value {
    display: flex;
    justify-content: center;
    font-family: 'Kulim Park';
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: 0.04em;
    color: ${p => p.theme.colors.main.orangeMain};
    align-items: center;
    padding: 0px;
    margin: 0px;
  }
  .wallet-select__menu {
    margin: 0px;
    padding: 0px;
    border-radius: 0px 0px 16px 16px;
    background: ${p => p.theme.colors.main.white};
    box-shadow: ${p => p.theme.modal.selectMenuFloater};
  }
  .wallet-select__menu-list {
    margin: 0px;
    padding: 0px;
  }
  .wallet-select__option {
    display: flex;
    align-items: center;
    font-family: 'Kulim Park';
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: 0.04em;
    color: ${p => p.theme.colors.main.orangeMain};
    background: ${p => p.theme.colors.main.white};
  }
  .wallet-select__option--is-focused {
    background: ${p => p.theme.colors.main.orangeLight};
  }
  .wallet-select__option--is-selected {
    background: ${p => p.theme.colors.main.orangeLight};
  }
`;
export const TransferWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: 7px;
  margin-bottom: 16px;
`;
export const WalletTransferSelect = styled(WalletSelect)`
`